export default function DrawerReducer(state = {}, action) {
    switch (action.type) {
      case "HANDLE_DRAWER":
        return Object.assign({}, state, {
          isExpanDrawer: action.data
        });
      default:
        return state
    }
  }
  


// WEBPACK FOOTER //
// ./src/modules/common/reducer.js